export default __webpack_public_path__ + "static/media/pizzaLogo.fcdc67e6.png";